import React, { useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import helpers from "helpers/helpers"
import numeral from "numeral"
import FullTable from "components/FullTable"
import moment from "moment"

const HomeSalesBuilder = (props) => {
	let columns = [
		{
			Header: "Builder",
			accessor: "builder",
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
	]
	let model = {}
	let earliest = Number.MAX_SAFE_INTEGER
	let latest = 0
	_.forEach(props.payload.sales.current, (v) => {
		if (v.sale_date < earliest) earliest = v.sale_date
		if (v.sale_date > latest) latest = v.sale_date
	})
	_.forEach(props.payload.bustouts.current, (v) => {
		if (v.bustout_date < earliest) earliest = v.bustout_date
		if (v.bustout_date > latest) latest = v.bustout_date
	})

	let current = moment.unix(earliest).startOf("month")
	let end = moment.unix(latest).endOf("month")
	while (current.isSameOrBefore(end)) {
		let key = current.format("MMM-YY")
		model[key] = 0
		current.add(1, "month")
	}
	_.forEach(model, (v, k) => {
		columns.push({
			Header: k,
			accessor: k,
			Cell: (row) => numeral(row.value).format("0,0"),
			Footer: (props) => helpers.tableTotals(props, k, "0,0"),
		})
	})
	let builders = {}
	_.forEach(props.payload.sales.current, (v) => {
		let bd = _.find(props.payload.public.builders, { id: v.builder })
		if (!bd) return
		if (!_.has(builders, bd.name)) {
			builders[bd.name] = _.clone(model)
		}
	})
	_.forEach(props.payload.bustouts.current, (v) => {
		let bd = _.find(props.payload.public.builders, { id: v.builder })
		if (!bd) return
		if (!_.has(builders, bd.name)) builders[bd.name] = _.clone(model)
	})
	_.forEach(props.payload.sales.current, (v) => {
		let sale_month = moment.unix(v.sale_date).format("MMM-YY")
		let bd = _.find(props.payload.public.builders, { id: v.builder })
		builders[bd.name][sale_month]++
	})
	_.forEach(props.payload.bustouts.current, (v) => {
		let bustout_month = moment.unix(v.bustout_date).format("MMM-YY")
		let bd = _.find(props.payload.public.builders, { id: v.builder })
		builders[bd.name][bustout_month]--
	})
	let d = []
	_.forEach(builders, (months, name) => {
		d.push({
			builder: name,
			...months,
		})
	})
	return (
		<>
			<h3>Net Home Sales By Builder By Month</h3>
			<FullTable
				data={d}
				columns={columns}
				classNames={"small"}
				defaultPageSize={20}
				name="homeSalesBuilder"
				title="Home Sales By Builder"
			/>
		</>
	)
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(HomeSalesBuilder)
